import { Injectable } from '@angular/core';
import { LibraryV2DataService } from 'src/app/core/services/library-v2/library-v2-data.service';
import { GlobalConstants } from '../../../../common/constants/global.constant';
import { QrCodeService } from 'src/app/core/services/qr-input-service/qr-input.service';

@Injectable({
  providedIn: 'root'
})
export class AidemosService {
  constructor(
     private libraryService: LibraryV2DataService,
  ) { }

  getAIDemosData() { 
    const panelData = this.libraryService.getAIDemoTilesData();
    return panelData;
  }
}
